export default "__VITE_ASSET__DpiHGBX7__"